import { CardMedia, Grid } from '@material-ui/core';
import usePortalStyles from '../../../layouts/PortalLayout/usePortalStyles';
import useCompanyBranding from '../../../utilities/useCompanyBranding';

const SignUpHeader = () => {
    const portalStyles = usePortalStyles();
    const { logoUrl } = useCompanyBranding();

    return (
        <Grid xs={12} item>
            <CardMedia className={portalStyles.logo} image={logoUrl} />
        </Grid>
    );
};

export default SignUpHeader;
